<!-- src/views/map/index.vue -->
<template>
  <div style="height: 100%; width: 100%">
    <!-- Map Mode Switch - Top Right Corner -->
    <div class="map-mode-switch" v-if="showSatSwitch">
      <div class="switch-container">
        <span class="mode-label" :class="{ 'active': mapMode === 'standard' }">Standard</span>
        <b-form-checkbox
          v-model="isSatMode"
          switch
          @change="toggleMapMode"
          class="mode-switch-checkbox"
        ></b-form-checkbox>
        <span class="mode-label" :class="{ 'active': mapMode === 'sat' }">Sat</span>
      </div>
    </div>

    <div class="coordinates-box" v-if="isShowed">
      <div class="coordinates-control">
        <button class="btn btn-sm btn-outline-mantraz mr-1" @click="prevCoordinatesPage">&lt;</button>
        <button class="btn btn-sm btn-outline-mantraz mr-1" @click="nextCoordinatesPage">&gt;</button>
        <h5 class="d-block text-muted text-left font-weight-bold ml-1">Line {{ coordinateOptions.activeLines }}</h5>
      </div>
      <hr class="w-100 m-0" />
      <div class="coordinates-control">
        <div class="d-flex flex-column">
          <span class="d-block text-muted small text-left font-weight-bold mb-2">Speed</span>
          <input type="number" class="form-control" style="width: 70px" v-model="coordinateOptions.speed">
        </div>
        <div class="d-flex flex-column">
          <span class="d-block text-muted small text-left font-weight-bold mb-2">Unit</span>
          <select class="form-control" v-model="coordinateOptions.unit">
            <option value="KM - KM/H">KM - KM/H</option>
            <option value="NM - KNOTS">NM - KNOTS</option>
          </select>
        </div>
        <div class="d-flex flex-column">
          <span class="d-block text-muted small text-left font-weight-bold mb-2">Date & Time</span>
          <div class="d-flex">
            <input type="date" class="form-control mr-1" style="width: 135px" v-model="coordinateOptions.date">
            <input type="time" class="form-control" style="width: 135px" v-model="coordinateOptions.time">
          </div>
        </div>
        <div class="d-flex flex-column">
          <span class="d-block text-muted small text-left font-weight-bold mb-2">&nbsp;</span>
          <button class="btn btn-success" @click="exportData">Export Excel</button>
        </div>
      </div>
      <table class="coordinates-table">
        <tr>
          <th>From</th>
          <th>To</th>
          <th>Heading</th>
          <th>Speed ({{ coordinateOptions.unit == 'NM - KNOTS' ? 'KNOTS' : 'KM/H' }})</th>
          <th>ETA</th>
          <th>Distance ({{ coordinateOptions.unit == 'NM - KNOTS' ? 'NM' : 'KM' }})</th>
          <th>Duration</th>
        </tr>
        <tr v-for="(item, index) of mappedCoordinates.tableData" :key="index" class="monospaced">
          <td>{{ item?.from?.lat + ' ' + item?.from?.lng }}</td>
          <td>{{ item?.to?.lat + ' ' + item?.to?.lng }}</td>
          <td>{{ item?.heading }}</td>
          <td>{{ item?.speed }}</td>
          <td>{{ item?.eta }}</td>
          <td>{{ item?.distance }}</td>
          <td>{{ item?.duration }}</td>
        </tr>
        <tr>
          <th colspan="5" class="text-right">Total</th>
          <td>{{ mappedCoordinates.totalDistance }}</td>
          <td>{{ mappedCoordinates.totalDuration }}</td>
        </tr>
      </table>
    </div>

    <!-- Container untuk Peta -->
    <div id="map" v-if="SelectedMap === 'default'"></div>
    <div style="height: 100%;" v-else-if="SelectedMap === 'windy'">
      <button class="toggle-btn btn btn-sm btn-secondary" id="toggle-btn">Weather Maps Options</button>
      <div id="button-container" class="hidden">
        <div class="button-row"><span class="button-label">Current Unit:</span><button class="btn btn-sm btn-primary" id="btn-metric">kt</button></div>
        <hr />
        <div class="button-row"><span class="button-label">Num Direction:</span><button class="btn btn-sm btn-primary" id="btn-num-direction">off</button></div>
        <hr />
        <div class="button-row"><span class="button-label">Graticule:</span><button class="btn btn-sm btn-primary" id="btn-graticule">off</button></div>
        <hr />
        <div class="button-row"><span class="button-label">Lat Long:</span><button class="btn btn-sm btn-primary" id="btn-latlon">on</button></div>
        <hr />
        <div class="button-row"><span class="button-label">Particle Animation:</span><button class="btn btn-sm btn-primary" id="btn-particles-anim">on</button></div>
        <hr />
        <div class="button-row"><span class="button-label">Isolines:</span><button class="btn btn-sm btn-primary" id="btn-isolines">off</button></div>
      </div>
      <div id="windy" style="height: 100%;"></div>
    </div>

    <!-- Ship Status Legend - Bottom Right -->
    <div v-if="showShipStatus" class="ship-status-legend" :class="{ 'collapsed': isLegendCollapsed }">
      <div class="legend-header" @click="toggleLegend">
        <h6 class="legend-title">Ship Status</h6>
        <button class="legend-toggle-btn">
          <svg v-if="isLegendCollapsed" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 7.5L6 4L2.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="legend-content" v-show="!isLegendCollapsed">
        <div class="ship-count-summary">
          <div class="count-item">
            <span class="count-label">Total Ships:</span>
            <span class="count-value">{{ totalShips }}</span>
          </div>
        </div>
        <div class="legend-item">
          <span class="legend-color ship-online"></span>
          <span class="legend-label">Online</span>
          <span class="legend-count">{{ onlineCount }}</span>
        </div>
        <div class="legend-item">
          <span class="legend-color ship-offline"></span>
          <span class="legend-label">Offline</span>
          <span class="legend-count">{{ offlineCount }}</span>
        </div>
        <div class="legend-item">
          <span class="legend-color ship-no-gps"></span>
          <span class="legend-label">No GPS</span>
          <span class="legend-count">{{ noGpsCount }}</span>
        </div>
        <div class="legend-item">
          <span class="legend-color ship-no-sensor"></span>
          <span class="legend-label">No Sensor</span>
          <span class="legend-count">{{ noSensorCount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { formatDateTime } from '@/util/date';
import * as coordinateUtils from '@/views/map/utils/coordinates.js';

import MapService from './services/mapService.js';
import { exportCoordinates } from './services/excelService.js';

export default {
  name: 'Map',
  props: {
    ships: {
      type: Array,
      required: true,
    },
    SelectedMap: {
      type: String,
      required: false,
      default: 'default',
    },
    Options: {
      type: Object,
      required: false,
    },
    showShipStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mapService: null,
      mapMode: 'standard', // 'standard' or 'sat'
      isSatMode: false,
      coordinateOptions: {
        speed: 1,
        unit: 'NM - KNOTS',
        date: formatDateTime(new Date(), 'YYYY-MM-DD'),
        time: formatDateTime(new Date(), 'HH:mm'),
        activeLines: 1,
        totalLines: 0,
      },
      coordinates: {},
      isShowed: false,
      isTrailLoading: {},
      isLegendCollapsed: false,
    };
  },
  mounted() {
    this.mapService = new MapService(this);

    // Expose Vue instance to window for popup button click handler
    window.mapServiceVm = this;

    // Load legend collapse state from localStorage
    const savedLegendState = localStorage.getItem('shipLegendCollapsed');
    if (savedLegendState !== null) {
      this.isLegendCollapsed = JSON.parse(savedLegendState);
    }

    if (this.SelectedMap === 'default') {
      this.loadLeafletCSS();
      this.$nextTick(() => {
        this.mapService.initializeDefaultMap('map');
      });
    } else if (this.SelectedMap === 'windy') {
      this.unloadLeafletCSS();
      this.$nextTick(() => {
        this.mapService.initializeWindyMap('windy');
      });
    }
  },
  beforeDestroy() {
    if (this.mapService) {
      this.mapService.destroy();
      this.mapService = null;
    }
    // Clean up window reference
    window.mapServiceVm = null;
  },
  computed: {
    totalShips() {
      return this.ships?.length || 0;
    },
    onlineCount() {
      return this.ships?.filter((ship) => ship.shipStatus === 'online').length || 0;
    },
    offlineCount() {
      return this.ships?.filter((ship) => ship.shipStatus === 'offline').length || 0;
    },
    noGpsCount() {
      return this.ships?.filter((ship) => ship.shipStatus === 'no-gps').length || 0;
    },
    noSensorCount() {
      return this.ships?.filter((ship) => ship.shipStatus === 'no-sensor').length || 0;
    },
    mappedCoordinates() {
      if (!this.isShowed || Object.keys(this.coordinates).length === 0) {
        return { tableData: [], totalDistance: '0.00', totalDuration: '00:00:00' };
      }

      const activeLineIndex = this.coordinateOptions.activeLines - 1;
      if (activeLineIndex < 0 || activeLineIndex >= Object.keys(this.coordinates).length) {
        return { tableData: [], totalDistance: '0.00', totalDuration: '00:00:00' };
      }

      const selectedLines = Object.values(this.coordinates)[activeLineIndex];
      if (!selectedLines || selectedLines.length < 2) {
        return { tableData: [], totalDistance: '0.00', totalDuration: '00:00:00' };
      }

      const departureTime = moment(`${this.coordinateOptions.date} ${this.coordinateOptions.time}:00`, 'YYYY-MM-DD HH:mm:ss');
      let totalDistance = 0;
      let totalDuration = 0;

      const mappedLines = selectedLines.slice(0, -1).map((currLines, idx) => {
        const nextLines = selectedLines[idx + 1];
        const heading = coordinateUtils.calculateHeading(currLines?.lat, currLines?.lng, nextLines?.lat, nextLines?.lng);
        const distance = coordinateUtils.calculateDistance(currLines?.lat, currLines?.lng, nextLines?.lat, nextLines?.lng);
        const defaultSpeed = this.coordinateOptions.speed;
        let convertedDistance = distance;

        if (this.coordinateOptions.unit === 'KM - KM/H') {
          convertedDistance /= 1000;
        } else if (this.coordinateOptions.unit === 'NM - KNOTS') {
          convertedDistance /= 1852;
        }

        const speedInKmh = this.coordinateOptions.unit === 'NM - KNOTS' ? defaultSpeed * 1.852 : defaultSpeed;
        const durationInHours = (distance / 1000) / speedInKmh;
        const durationInHHMMSS = coordinateUtils.formatDuration(durationInHours);

        const etaMoment = moment(departureTime).add(durationInHours, 'hours');

        totalDistance += convertedDistance;
        totalDuration += durationInHours;

        const fromPoint = {
          lat: coordinateUtils.convertDecimalToDMS(currLines?.lat, true),
          lng: coordinateUtils.convertDecimalToDMS(currLines?.lng, false),
        };
        const toPoint = {
          lat: coordinateUtils.convertDecimalToDMS(nextLines?.lat, true),
          lng: coordinateUtils.convertDecimalToDMS(nextLines?.lng, false),
        };

        departureTime.add(durationInHours, 'hours');

        return {
          from: fromPoint,
          to: toPoint,
          distance: convertedDistance?.toFixed(2),
          heading: heading?.toFixed(2),
          duration: durationInHHMMSS,
          speed: defaultSpeed,
          eta: etaMoment.format('YYYY-MM-DD HH:mm:ss'),
        };
      });

      return {
        tableData: mappedLines,
        totalDistance: totalDistance?.toFixed(2),
        totalDuration: coordinateUtils.formatDuration(totalDuration),
      };
    },
    showSatSwitch() {
      // Check if we're on home page and at least one asset has massSateliteId
      const isHomeRoute = this.$route?.name === 'Home';
      const hasSatelliteAssets = this.ships?.some((ship) => ship.massSateliteId && ship.massSateliteId !== '' && ship.massSateliteId !== 'null' && ship.massSateliteId !== 'undefined');
      return isHomeRoute && hasSatelliteAssets;
    },
  },
  methods: {
    viewSatelliteDatalog(massId) {
      this.$router.push({
        path: '/report',
        query: { menu: 'SatelliteDatalog' },
      }).then(() => {
        this.$store.dispatch('filter/setCurrentMassId', massId);
      });
    },
    toggleMapMode() {
      this.mapMode = this.isSatMode ? 'sat' : 'standard';
      this.$emit('map-mode-change', this.mapMode);
      this.handleGetLastData(this.mapMode);
    },

    async handleGetLastData(mode = 'standard') {
      await this.$store.dispatch('asset/getLastData', mode);
    },

    handlePolylineChange(currentLine) {
      this.isShowed = false;
      if (!currentLine) return;
      const circleCoords = JSON.stringify(currentLine.circleCoords);
      this.$set(this.coordinates, `line-${currentLine.id}`, JSON.parse(circleCoords));
      this.coordinateOptions.totalLines = Object.keys(this.coordinates).length;
      this.isShowed = true;
    },

    handlePolylineClear() {
      this.coordinates = {};
      this.isShowed = false;
    },

    handlePolylineFinish() {
      this.isShowed = true;
    },

    handlePolylineStart() {
      this.isShowed = false;
    },

    handleClickDashboard(massId) {
      this.$store.dispatch('filter/setCurrentMassId', massId);
      this.$router.push({ name: 'FmsDashboard' });
    },

    async handleFetchAllLastSummary(mode = 'standard') {
      await this.$store.dispatch('asset/fetchAllLastSummary', mode);
    },

    handleClickReport(massId) {
      this.$store.dispatch('filter/setCurrentMassId', massId);
      this.$router.push({ name: 'ReportWrapper', query: { menu: 'ReportSummary' } });
    },

    handleClickVoyage(massId) {
      this.$store.dispatch('filter/setCurrentMassId', massId);
      this.$router.push({ name: 'ReportWrapper', query: { menu: 'VoyageReport' } });
    },

    nextCoordinatesPage() {
      if (this.coordinateOptions.activeLines < this.coordinateOptions.totalLines) {
        this.coordinateOptions.activeLines += 1;
      }
    },
    prevCoordinatesPage() {
      if (this.coordinateOptions.activeLines > 1) {
        this.coordinateOptions.activeLines -= 1;
      }
    },
    async exportData() {
      try {
        await exportCoordinates(this.mappedCoordinates, this.coordinateOptions.unit);
      } catch (e) {
        console.error('Failed to export Excel data:', e);
      }
    },

    loadLeafletCSS() {
      if (!document.querySelector('link[href="/style/leaflet.css"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/style/leaflet.css';
        document.head.appendChild(link);
      }
      if (!document.querySelector('link[href="/style/Leaflet.PolylineMeasure.css"]')) {
        const link2 = document.createElement('link');
        link2.rel = 'stylesheet';
        link2.href = '/style/Leaflet.PolylineMeasure.css';
        document.head.appendChild(link2);
      }
    },
    unloadLeafletCSS() {
      const link = document.querySelector('link[href*="style/leaflet.css"]');
      if (link) link.parentNode.removeChild(link);
      const link2 = document.querySelector('link[href*="style/Leaflet.PolylineMeasure.css"]');
      if (link2) link2.parentNode.removeChild(link2);
    },
    toggleLegend() {
      this.isLegendCollapsed = !this.isLegendCollapsed;
      localStorage.setItem('shipLegendCollapsed', JSON.stringify(this.isLegendCollapsed));
    },
  },
  watch: {
    ships: {
      async handler() {
        if (this.mapService) {
          await this.mapService.refreshShips();
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
/* Semua style dari file asli tetap di sini */
#map {
  height: 100%;
  width: 100%;
}

/* Map Mode Switch - Top Right Corner */
.map-mode-switch {
  position: fixed;
  top: 85px;
  right: 20px;
  z-index: 998;
  background: #ffffff;
  border-radius: 20px;
  padding: 8px 14px;
  border: 2px solid #ff69b4;
  display: inline-block;
}

.switch-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.mode-label {
  font-size: 13px;
  font-weight: 700;
  color: #9ca3af;
  transition: all 0.25s ease;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  padding: 4px 8px;
  border-radius: 6px;
}

.mode-label.active {
  color: #ffffff;
  background-color: #ff69b4;
  font-weight: 800;
}

.mode-switch-checkbox {
  flex-shrink: 0;
  padding-left: 0 !important;
}

.mode-switch-checkbox .custom-control-label {
  cursor: pointer;
  width: 50px;
  height: 26px;
  margin-bottom: 0;
}

.mode-switch-checkbox .custom-control-label::before {
  width: 50px;
  height: 26px;
  border-radius: 13px;
  background-color: #e5e7eb;
  transition: all 0.3s ease;
  left: 0;
  top: 0;
  position: absolute;
}

.mode-switch-checkbox .custom-control-label::after {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ffffff;
  top: 2px;
  left: 2px;
  transition: all 0.3s ease;
  position: absolute;
}

.mode-switch-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ff69b4;
}

.mode-switch-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(24px);
}

.mode-switch-checkbox:hover .custom-control-label::before {
  background-color: #d1d5db;
}

.mode-switch-checkbox:hover .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ff87c2;
}

.ship-label {
  font-size: 13px; font-weight: 1000; text-align: center; color: #ffffff;
  padding: 3px 5px; border-radius: 5px;
}
.ship-online { background-color: #16b961; }
.ship-offline { background-color: #ff3b30; }
.ship-no-gps { background-color: #9CA3AF; }
.ship-no-sensor { background-color: #F97316; }
.leaflet-popup-content-wrapper {
  border-radius: 10px; border: 1px solid #ffffff; background-color: #ffffff !important;
  color: #1e1e1e; font-weight: 500; width: 340px; padding: 5px;
}
.status { margin-left: 10px; padding: 1px 5px; border-radius: 5px; font-weight: 600; }
.online { background-color: #d7f0d8; color: #38ac3d; }
.offline { background-color: #ffe4e4; color: #f24848; }
.no-gps { background-color: #e5e7eb; color: #6b7280; }
.no-sensor { background-color: #ffedd5; color: #ea580c; }
.tooltip-button { width: 100%; font-weight: 700; }
hr { margin: 0; }
.btn-outline-mantraz { border-color: #ff69b4 !important; color: #ff69b4 !important; }
.btn-outline-mantraz:hover { background-color: #ff69b4 !important; color: #fff !important; }
.btn-mantraz { background-color: #ff69b4 !important; color: #fff !important; }
.leaflet-map-settings {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.map-settings-toggle {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #ffffff;
  color: #264284;
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.map-settings-toggle i {
  font-size: 18px;
}
.map-settings-toggle:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.16);
}
.map-settings-panel {
  width: 210px;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 12px;
  padding: 10px 12px;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.14);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.map-settings-panel.hidden {
  display: none;
}
.map-settings-header {
  font-size: 12px;
  font-weight: 700;
  color: #1f2937;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.map-settings-separator {
  height: 1px;
  background: #e5e7eb;
  margin: 2px 0;
}
.map-settings-option,
.map-settings-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
}
.map-settings-option input,
.map-settings-switch input {
  width: 16px;
  height: 16px;
  margin: 0;
}
.map-icon-sample {
  margin-left: auto;
  height: 22px;
  width: auto;
  object-fit: contain;
}
.map-settings-size {
  display: flex;
  align-items: center;
  gap: 8px;
}
.map-settings-size input[type="range"] {
  flex: 1;
  height: 4px;
  margin: 0;
  accent-color: #ff69b4;
  cursor: pointer;
}
.map-settings-size-value {
  font-size: 12px;
  font-weight: 700;
  color: #1f2937;
  min-width: 38px;
  text-align: right;
}
.landmark-cluster-wrapper {
  background: transparent;
  border: none;
}
.landmark-cluster {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 105, 180, 0.9);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.coordinates-box {
  position: absolute; bottom: 20px; right: 20px; height: 75%; width: 40%;
  border: 1px solid #ccc; background-color: white; overflow-y: auto;
  z-index: 1000; border-radius: 15px;
}
.coordinates-control {
  display: flex; padding: 10px 15px; background-color: white; position: sticky;
  top: 0; left: 0; z-index: 10; border-bottom: 1px solid #ccc; width: 100%; overflow: scroll;
}
.coordinates-control div { margin-right: 5px; }
.coordinates-table {
  width: 100%; border-collapse: collapse; font-size: 14px;
  font-weight: 500; border: 1px solid #DFE3E7; margin-bottom: 1rem; color: #727E8C;
}
.coordinates-table th, .coordinates-table td {
  padding: 5px 10px; vertical-align: center; border: 1px solid #DFE3E7; white-space: nowrap;
}
.coordinates-table th {
  text-align: center;
  position: sticky;
  top: 85px;
  background-color: white;
  z-index: 5;
}

.coordinates-table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #DFE3E7;
}

.coordinates-table tbody+tbody {
  border-top: 2px solid #DFE3E7;
}

/* Ship Status Legend - Bottom Right */
.ship-status-legend {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.12);
  z-index: 1000;
  min-width: 140px;
  transition: all 0.3s ease;
}

.ship-status-legend.collapsed {
  padding: 8px 12px;
}

.legend-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.legend-toggle-btn {
  background: none;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  color: #6b7280;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.legend-toggle-btn:hover {
  color: #1f2937;
}

.legend-toggle-btn svg {
  display: block;
}

.legend-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e5e7eb;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ship-status-legend.collapsed .legend-title {
  padding-bottom: 0;
  border-bottom: none;
  margin-bottom: 0;
}

.ship-count-summary {
  margin-bottom: 10px;
}

.count-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.count-label {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
}

.count-value {
  font-size: 14px;
  font-weight: 700;
  color: #6b7280;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.legend-item:last-child {
  margin-bottom: 0;
}

.legend-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  flex-shrink: 0;
}

.legend-label {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  flex-grow: 1;
}

.legend-count {
  font-size: 14px;
  font-weight: 700;
  color: #6b7280;
  min-width: 24px;
  text-align: right;
}

#logo img {
  display: none !important;
}
</style>
